import { render, staticRenderFns } from "./JourneyConnectionEmailCampaign.vue?vue&type=template&id=66db55a4&scoped=true&"
import script from "./JourneyConnectionEmailCampaign.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionEmailCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66db55a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66db55a4')) {
      api.createRecord('66db55a4', component.options)
    } else {
      api.reload('66db55a4', component.options)
    }
    module.hot.accept("./JourneyConnectionEmailCampaign.vue?vue&type=template&id=66db55a4&scoped=true&", function () {
      api.rerender('66db55a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionEmailCampaign.vue"
export default component.exports